module.exports = __webpack_public_path__ + "img/add-btn.f7f2516e.svg";